<template lang="pug">
v-card
  v-card-text
    div {{ `\{${component}\}` }}
</template>

<script>
export default {
  props: {
    site: String,
    eref: String,
    form: Object,
    data: Object,
    entity: Object,

    busy: Boolean,

    // @type {Keep.Paper.Design.Entity}
    pagelet: Object,
  },

  computed: {
    type: vm => vm.pagelet?.type || 'Unknown',
    component: vm => `Pagelet${vm.type}`,
  },
}
</script>